import { DateTime } from "luxon";

const INTERVAL_TIME = 30 * 1000;
const MINUTES_BEFORE_EXPIRATION = 10;
let currentTimer: string | number | NodeJS.Timeout | undefined;

onmessage = (e) => {
  const { currentTokenExpDate, stopWorker = false } = e.data;

  if (currentTimer) {
    clearInterval(currentTimer);
    currentTimer = undefined;
  }

  if (stopWorker) {
    return;
  }

  function checkTokenExp(currentTokenExpDate: Date) {
    const currentTime = DateTime.utc().toMillis();
    const expiration = DateTime.fromJSDate(currentTokenExpDate)
      .toUTC()
      .toMillis();
    const timeUntilExpiration = expiration - currentTime;
    const timeToUpdate = MINUTES_BEFORE_EXPIRATION * 60 * 1000;
    postMessage({ result: timeUntilExpiration <= timeToUpdate });
  }

  currentTimer = setInterval(function () {
    checkTokenExp(currentTokenExpDate);
  }, INTERVAL_TIME);
};
